import { Button } from "primereact/button";
import React, { useEffect, useState, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dialog } from "primereact/dialog";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import AddEditVehicleType from "./AddEditVehicleType";
// import appUrl from "../../../config/appUrl";
import { Image } from "primereact/image";
import appUrl from "../../../config/appUrl";
const ManageVehicleType = () => {
  const [displayDialog, setDisplayDialog] = useState(false);
  const [addEditVehicleType, setAddEditVehicleType] = useState(false);
  const [vehicleTypeList, setVehicleTypeList] = useState([]);
  const [vehicleTypeId, setVehicleTypeId] = useState("");

  const editVehicleType = (rowData) => {
    setDisplayDialog(true);
    setAddEditVehicleType(true);
    setVehicleTypeId(rowData?._id);
  };

  const onHide = (name) => {
    setDisplayDialog(false);
  };

  const handleDialog = () => {
    setDisplayDialog(true);
  };

  const getVehicleTypeList = async () => {
    try {
      const response = await fetch(`${appUrl.BASE_URL}category`);
      const data = await response.json();
      setVehicleTypeList(data);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getVehicleTypeList();
  }, []);

  const actionTemp = (rowData) => {
    return (
      <div className="flex">
        <Button
          tooltip="Edit"
          icon="pi pi-user-edit"
          tooltipOptions={{ position: "top" }}
          onClick={() => editVehicleType(rowData)}
          className="p-button-rounded p-button-text"
        />
        <Button
          tooltip="Delete"
          tooltipOptions={{ position: "top" }}
          onClick={() => confirm(rowData)}
          icon="pi pi-trash"
          className="p-button-rounded p-button-text"
        />
      </div>
    );
  };

  const confirm = (rowData) => {
    confirmDialog({
      message: "Do you want to delete this record?",
      header: "Delete Confirmation",
      icon: "pi pi-info-circle",
      acceptClassName: "p-button-primary",
      rejectClassName: "p-button-danger",
      accept: () => onDeleteConfirmation(rowData),
      reject,
    });
  };

  const onDeleteConfirmation = async (rowData) => {
    try {
      const response = await fetch(
        `${appUrl.BASE_URL}category?categoryId=${rowData?._id}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      const data = await response.json();

      if (response.ok) {
        await getVehicleTypeList();
      } else {
        console.error(data?.msg); // Error message from the API
      }
    } catch (error) {
      console.error(error);
    }
  };

  const reject = () => { };

  const icon = (rowData) => {
    return (
      <>
        <div className="vehicle-icon">
          <Image
           src={appUrl.BASE_URL + rowData?.icon}
            alt="Vehicle Image"
            preview
          />
        </div>
      </>
    );
  };

  return (
    <>
      <Dialog
        draggable={false}
        visible={displayDialog}
        style={{ width: "55vw" }}
        onHide={() => onHide("displayDialog")}
      >
        <AddEditVehicleType
          onHide={onHide}
          getVehicleTypeList={getVehicleTypeList}
          addEditVehicleType={addEditVehicleType}
          vehicleTypeId={vehicleTypeId}
          vehicleTypeList={vehicleTypeList}
        />
      </Dialog>

      <ConfirmDialog />

      <div>
        <div className="p-fluid grid align-items-center">
          <div className="col-12 md:col-10">
            <div className="flex align-items-center">
              <h5
                className="mt-0 text-2xl mb-0 font-semibold text-[#17171B]"
                style={{ color: "#17171B" }}
              >
                Vehicle Type Management
              </h5>
            </div>
          </div>

          <div className="col-12 md:col-2 text-right">
            <Button
              label="Add New"
              className="Add__New-Button"
              aria-label="Add Vehicle Type"
              onClick={() => {
                handleDialog();
                setAddEditVehicleType(false);
              }}
              icon="pi pi-plus"
              iconPos="right"
            />
          </div>
        </div>
      </div>

      <div className="card custom_card p-datatable-sm">
        <DataTable
          scrollable
          // scrollHeight="382px"
          responsiveLayout="scroll"
          paginator
          rows={10}
          value={vehicleTypeList}
          emptyMessage="No data found."
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
          rowsPerPageOptions={[10, 20, 30, 40, 50, 60, 70, 80, 90, 100]}
        >
          <Column field="name" header="Name"></Column>
          {/* <Column field="fee" header="Fee"></Column> */}
          <Column body={icon} header="Icon"></Column>
          <Column body={actionTemp} header="Action"></Column>
        </DataTable>
      </div>
    </>
  );
};

export default ManageVehicleType;
